"use strict";
/*
 * Created on 01 14 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../DomainObject");

var ResultSeverity_1 = require("./ResultSeverity");

var ValidationResultObject_1 = require("./ValidationResultObject");
/**
 * Wrapper object that represents generic validation result. It should not be limited to use within web API, but application
 * layer as well. It holds list of {@link ValidationResultObject validation result objects} and you can create results of
 * complex validation within single validation. You can specify optional generic parameter to restrict validation keys to some ENUM type.
 *
 * @author JMe
 */


var ValidationResult =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ValidationResult, _DomainObject_1$Domai);

  /**
   * @param resultObjects
   */
  function ValidationResult() {
    var _this;

    var resultObjects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : immutable_1.List();

    _classCallCheck(this, ValidationResult);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ValidationResult).call(this));
    _this.resultObjects = resultObjects;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to final price.
   */


  _createClass(ValidationResult, [{
    key: "isSuccessful",

    /**
     * @returns true if no validation result object is an error, false otherwise
     */
    value: function isSuccessful() {
      return !this.resultObjects.some(function (i) {
        return i.severity === ResultSeverity_1.ResultSeverity.Error;
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.resultObjects.isEmpty();
    }
    /**
     * Adds new message. Returns updated validation result.
     * @param object validation result object
     * @returns new copy of validation result with added result object
     */

  }, {
    key: "addObject",
    value: function addObject(object) {
      return this.copy('resultObjects', this.resultObjects.push(object));
    }
    /**
     * Adds new message if this message is not present yet. Returns updated validation result.
     * @param object validation result object
     * @returns new copy of validation result with added result object (if not already present)
     */

  }, {
    key: "addObjectIfNotPresent",
    value: function addObjectIfNotPresent(object) {
      if (!this.hasMessage(object.messageKey, object.messageVariables)) {
        return this.copy('resultObjects', this.resultObjects.push(object));
      }

      return this;
    }
    /**
     * @param messageKey Key based on which msg should be found.
     * @returns {@link ValidationResultObject} by provided message key if there is any.
     */

  }, {
    key: "getMessageWithKey",
    value: function getMessageWithKey(messageKey) {
      return this.resultObjects.find(function (o) {
        return o.messageKey === messageKey;
      });
    }
    /**
     * Returns true if this validation result contains message with given key.
     * @param messageKey
     */

  }, {
    key: "hasMessageWithKey",
    value: function hasMessageWithKey(messageKey) {
      return this.resultObjects.some(function (o) {
        return o.messageKey === messageKey;
      });
    }
    /**
     * Returns true if this validation result contains given message.
     */

  }, {
    key: "hasMessage",
    value: function hasMessage(messageKey, messageVariables) {
      return this.resultObjects.some(function (o) {
        return o.messageKey === messageKey && (messageVariables.isEmpty() && o.messageVariables.isEmpty() || o.messageVariables.equals(messageVariables));
      });
    }
    /**
     * Returns true if some validation result contains given flag.
     * @param flag
     */

  }, {
    key: "hasMessageWithFlag",
    value: function hasMessageWithFlag(flag) {
      return this.resultObjects.some(function (rObject) {
        return rObject.flags.has(flag);
      });
    }
    /**
     * Removes message with given key.
     * @param messageKey
     */

  }, {
    key: "removeObjectWithMessageKey",
    value: function removeObjectWithMessageKey(messageKey) {
      return this.copy('resultObjects', this.resultObjects.filter(function (o) {
        return o.messageKey !== messageKey;
      }));
    }
    /**
     * Removes messages with given keys.
     * @param messageKey
     */

  }, {
    key: "removeObjectsWithMessageKeys",
    value: function removeObjectsWithMessageKeys(messageKeys) {
      return this.copy('resultObjects', this.resultObjects.filter(function (o) {
        return !messageKeys.contains(o.messageKey);
      }));
    }
    /**
     * @param validationResult the validation result that should be merged with this
     * @returns new copy of validation result with merged result objects (this and given).
     */

  }, {
    key: "mergeWithResult",
    value: function mergeWithResult(validationResult) {
      var res = this;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = validationResult.resultObjects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var obj = _step.value;
          res = res.addObjectIfNotPresent(obj);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return res;
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ValidationResult(mat.resultObjects);
    }
    /**
     * Creates validation result with one message.
     */

  }, {
    key: "fromMessage",
    value: function fromMessage(msg) {
      return new ValidationResult(immutable_1.List.of(msg));
    }
  }]);

  return ValidationResult;
}(DomainObject_1.DomainObject);

exports.ValidationResult = ValidationResult;
ValidationResult.EMPTY = new ValidationResult();

ValidationResult.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ValidationResult.name);
  return {
    resultObjects: builder.listOf(builder.obj('resultObjects', ValidationResultObject_1.ValidationResultObject.schema, function (mat) {
      return ValidationResultObject_1.ValidationResultObject.fromDataDict(mat);
    }))
  };
}();